// data/items/bulwarks.js
// Melee offhand shields - 6 tiers matching metal progression
// Crafted via Smithing (bars only)

// Tier definitions matching metal bar tiers
// meleeAccuracy included for proper equipment set routing (detected by getItemCombatStyle)
const BULWARK_TIERS = {
    1: { prefix: 'Pyrestone', color: '#cd7f32', defenseBase: 6, hpBase: 5, blockBase: 2, meleeAccuracy: 0, combatLevel: 5, smithingLevel: 15, barCost: 4, valueBase: 150 },
    2: { prefix: 'Pale Shard', color: '#c0c0c0', defenseBase: 14, hpBase: 15, blockBase: 4, meleeAccuracy: 0, combatLevel: 20, smithingLevel: 30, barCost: 4, valueBase: 350 },
    3: { prefix: 'Blackiron', color: '#2d2d2d', defenseBase: 24, hpBase: 30, blockBase: 6, meleeAccuracy: 0, combatLevel: 35, smithingLevel: 45, barCost: 5, valueBase: 600 },
    4: { prefix: 'Skyiron', color: '#4169e1', defenseBase: 38, hpBase: 50, blockBase: 8, meleeAccuracy: 0, combatLevel: 50, smithingLevel: 60, barCost: 5, valueBase: 950 },
    5: { prefix: 'Verdant Core', color: '#228b22', defenseBase: 54, hpBase: 75, blockBase: 10, meleeAccuracy: 0, combatLevel: 65, smithingLevel: 75, barCost: 6, valueBase: 1400 },
    6: { prefix: 'Voidsteel', color: '#00ced1', defenseBase: 72, hpBase: 105, blockBase: 12, meleeAccuracy: 0, combatLevel: 80, smithingLevel: 90, barCost: 6, valueBase: 2000 }
};

// Bar IDs for each tier (matches smithing bar progression)
const BAR_IDS = {
    1: 'pyrestone_bar',
    2: 'pale_shard_bar',
    3: 'blackiron_bar',
    4: 'skyiron_bar',
    5: 'verdant_core_bar',
    6: 'voidsteel_bar'
};

// Bulwark sprites - only tiers with HD art
const BULWARK_SPRITES = {
    1: { sheet: 'assets/icons/equipment/meleeWeapons/pyrestone_bulwark.png', x: 0, y: 0, width: 64, height: 64 },
    2: { sheet: 'assets/icons/equipment/meleeWeapons/paleshard_bulwark.png', x: 0, y: 0, width: 64, height: 64 },
    3: { sheet: 'assets/icons/equipment/meleeWeapons/blackiron_bulwark.png', x: 0, y: 0, width: 64, height: 64 },
    4: { sheet: 'assets/icons/equipment/meleeWeapons/skyiron_bulwark.png', x: 0, y: 0, width: 64, height: 64 },
    5: { sheet: 'assets/icons/equipment/meleeWeapons/verdantcore_bulwark.png', x: 0, y: 0, width: 64, height: 64 },
    6: { sheet: 'assets/icons/equipment/meleeWeapons/voidsteel_bulwark.png', x: 0, y: 0, width: 64, height: 64 }
};

// Generate bulwark items
function generateBulwarks() {
    const bulwarks = [];

    for (let tier = 1; tier <= 6; tier++) {
        const tierData = BULWARK_TIERS[tier];
        const prefixId = tierData.prefix.toLowerCase().replace(/ /g, '_');

        const item = {
            id: `${prefixId}_bulwark`,
            name: `${tierData.prefix} Bulwark`,
            color: tierData.color,
            tier: tier,
            slot: 'offhand',
            offhandType: 'bulwark',  // For style validation
            meleeAccuracy: tierData.meleeAccuracy,  // For equipment set routing (shields provide no accuracy)
            defenseBonus: tierData.defenseBase,
            hpBonus: tierData.hpBase,
            blockChance: tierData.blockBase,  // % chance to block (50% damage reduction)
            combatLevel: tierData.combatLevel,
            smithingLevel: tierData.smithingLevel,
            barId: BAR_IDS[tier],
            barCost: tierData.barCost,
            value: tierData.valueBase
        };

        if (BULWARK_SPRITES[tier]) {
            item.sprite = { ...BULWARK_SPRITES[tier] };
        }

        bulwarks.push(item);
    }

    return bulwarks;
}

export const BULWARKS = generateBulwarks();

// Helper to get bulwark by tier
export function getBulwarkByTier(tier) {
    return BULWARKS.find(b => b.tier === tier);
}

// Export tier info for crafting UI
export { BULWARK_TIERS };

export default BULWARKS;
